import { render, staticRenderFns } from "./LoggersCfmItem.vue?vue&type=template&id=5d02aed7&"
import script from "./LoggersCfmItem.vue?vue&type=script&lang=js&"
export * from "./LoggersCfmItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports